<template>
<div class="myinfo_wrap">
    <div class="page_title_center">
        친구목록
    </div>   
    <div class="top_round_deco"></div>
    <div class="wrapper">
        <friends-list :isMobile="true"/>
    </div>
</div>
</template>
<script>
import FriendsList from '@/pages/message/FriendsList.vue'
export default {
    name:'',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{
        FriendsList  
    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/mobile';
</style>